import React from 'react';
import {useField} from 'formik';

interface ElogCheckboxProps {
    label: string;
    name: string;
    value?: string;
}

const ElogCheckbox: React.FC<ElogCheckboxProps> = ({label, name, value}) => {
    const [field] = useField({name, type: 'checkbox', value});

    return (
        <tr>
            <th>
                <label>{label}:</label>
            </th>
            <td>
                <input
                    {...field}
                    type="checkbox"
                    value={value}
                />
            </td>
        </tr>
    );
};

export default ElogCheckbox;